<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<h1 class="center">Contents</h1>
<p class="toc2" style="margin-top:60px;">Newly Revised Stories</p>
<p class="toc2"><a href="#/JustOvertheHorizon_1P3">SISTERS</a></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P4" title="Link target outside of Sample">A MARTIAN RICORSO</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P5" title="Link target outside of Sample">SCHRÖDINGER’S PLAGUE</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P6" title="Link target outside of Sample">BLOOD MUSIC</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P7" title="Link target outside of Sample">SILICON TIMES E-BOOK REVIEW</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P8" title="Link target outside of Sample">WARM SEA</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P9" title="Link target outside of Sample">TANGENTS</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P10" title="Link target outside of Sample">THROUGH ROAD NO WHITHER</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P11" title="Link target outside of Sample">DEAD RUN</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P12" title="Link target outside of Sample">THE WHITE HORSE CHILD</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P13" title="Link target outside of Sample">WEBSTER</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P14" title="Link target outside of Sample">THE VISITATION</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P15" title="Link target outside of Sample">RICHIE BY THE SEA</span></p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P16" title="Link target outside of Sample">SLEEPSIDE STORY</span></p>
<p class="toc2">Screenplay</p>
<p class="toc1"><span href="#/JustOvertheHorizon_1P17" title="Link target outside of Sample">GENIUS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// JustOvertheHorizon_1P2.vue?23ea57e6